import React from "react";
import {injectIntl} from "react-intl";

// core components
import FormikInput from "components/input/formikInput";

/**
 * Where the reason sits in the list the customer is shown on the eshop return portal.
 *
 * 0 is the top. Left empty, the reason goes to the bottom; reasons sharing a position — or all left
 * empty — fall back on their name, so the list never reorders itself between visits.
 */
function PositionField(props) {
    const {intl} = props;

    return (
        <FormikInput
            labelText={intl.formatMessage({id: 'cancellation_reason.form.label.position'})}
            inputProps={
                {
                    name: 'position',
                    type: 'number',
                    min: 0,
                    placeholder: intl.formatMessage({id: 'cancellation_reason.form.field.position.placeholder'}),
                }
            }
        />
    );
}

export default injectIntl(PositionField);
